import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgChevronRightEnd(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0042 3.56641C18.5564 3.56641 19.0042 4.01412 19.0042 4.56641V19.4337C19.0042 19.986 18.5564 20.4337 18.0042 20.4337C17.4519 20.4337 17.0042 19.986 17.0042 19.4337V4.56641C17.0042 4.01412 17.4519 3.56641 18.0042 3.56641ZM6.4261 4.24309L13.4731 11.2901C13.4812 11.2977 13.4893 11.3055 13.4972 11.3134C13.6994 11.5156 13.7969 11.7829 13.7897 12.0479C13.7832 12.2949 13.6857 12.5399 13.4972 12.7284C13.4895 12.7361 13.4817 12.7436 13.4738 12.751L6.42612 19.7987C6.0356 20.1892 5.40244 20.1892 5.01191 19.7987C4.62139 19.4082 4.62139 18.775 5.01191 18.3845L11.3755 12.0209L5.01189 5.6573C4.62136 5.26678 4.62136 4.63361 5.01189 4.24309C5.40241 3.85256 6.03558 3.85256 6.4261 4.24309Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightEnd);

var ChevronRightEndSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ChevronRightEndSolid as default };
